"use client";

import { ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Awareness() {
  const {
    ref: leftRef,
    isVisible: leftVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.1
  });
  const {
    ref: headlineRef,
    isVisible: headlineVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.1
  });
  return <section data-section-id="2793" id="keeping-awareness-fresh" className="relative w-full min-h-screen overflow-hidden bg-background text-foreground">
      <div className="relative flex flex-col min-h-screen">
        {}
        <div ref={leftRef} className={`relative w-full min-h-screen bg-background overflow-hidden transition-all duration-1000 ease-out ${leftVisible ? "opacity-100 translate-x-0" : "opacity-0 -translate-x-8"}`}>
          <img src="https://prime-egret.10web.cloud/wp-content/uploads/2026/06/Website-pic-1.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1717563/img/awareness_issue_neglect.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1717563/img/awareness_issue_neglect.png-wvc-sizes" alt="A faded, forgotten photograph representing an awareness issue that has lost public attention" loading="lazy" decoding="async" className="absolute inset-0 w-full h-full object-cover saturate-50 opacity-80 transition-all duration-[2000ms] ease-out hover:saturate-75 hover:opacity-90" src="https://prime-egret.10web.cloud/wp-content/uploads/2026/07/Website-pic-5.png" />
          <div className="absolute inset-0 bg-background/30" />

          {}
          <div className="absolute top-8 left-8 lg:top-12 lg:left-12 z-10">
            <div className="flex items-center gap-3">
              <span className="block h-px w-8 bg-foreground/40" />
            </div>
          </div>
        </div>

        {}
        <div ref={headlineRef} className={`absolute inset-0 flex items-center justify-center px-6 lg:px-12 z-20 pointer-events-none transition-all duration-1000 ease-out delay-300 ${headlineVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
          <div className="w-full max-w-5xl text-center pointer-events-auto">
            <h1 className="font-default font-light text-foreground leading-[1.02] tracking-tight text-5xl sm:text-6xl md:text-7xl lg:text-8xl xl:text-9xl">Keeping awareness issues 4ever <em className="italic font-normal" data-ast-id="f:/src/pages/Home/sections/Awareness.tsx|sig:a1hwmy" data-ast-start="2527" data-ast-end="2766" contenteditable="false" style={{
              color: 'var(--chart-1)'
            }}>fresh</em>.</h1>

            <p className="mt-8 lg:mt-10 mx-auto max-w-xl text-base md:text-lg font-default text-muted-foreground leading-relaxed">4EverFresh keeps important causes in front of people long after the moment passes. Learn the issues, support the cause, and help keep awareness fresh.</p>

            <div className="mt-10 lg:mt-12 flex flex-col sm:flex-row items-center justify-center gap-6">
              <Button asChild size="lg" className="group rounded-lg px-8 py-6 text-base font-medium shadow-md hover:shadow-lg transition-all bg-foreground text-background">
                <Link to="/CurrentCausesPage">
                  <span>Explore Causes</span>
                  <ArrowRight className="size-4 transition-transform duration-300 group-hover:translate-x-1" />
                </Link>
              </Button>

              <Link to="/AboutImpactPage" className="group relative inline-flex items-center text-sm font-medium text-foreground">
                <span>Our Mission</span>
                <span className="absolute -bottom-1 left-0 h-px w-0 bg-foreground transition-all duration-500 ease-out group-hover:w-full" />
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>;
}